import React from 'react'
import PropTypes from 'prop-types'
import WarningCard from '../../WarningCard'
import Button from '../../../../../components/Button/Button'
import { useNetworkStatus } from '../../../../../utils/networkStatus'
import MessageTimeSinceLastUpdate from '../../../../../components/MessageTimeSinceLastUpdate/MessageTimeSinceLastUpdate'
import AppRoutes from '../../../../../routes/appRoutes'
import { removeStepsAndRequests } from '../../../../../utils/handleOnDone'

const RenderFooter = ({
    steps,
    error,
    isValidForm,
    allowSubmitWithError,
    handleNextStep,
    history,
}) => {
    const activeStep = steps?.find(f => f.active === true)
    const checkDuplicateStep = activeStep?.name === 'Check Duplicates'
    const { isOffline } = useNetworkStatus()

    const buttonDisabled =
        activeStep?.name === 'Request Details'
            ? !isValidForm || (error != null && !allowSubmitWithError)
            : error != null

    const handleCancel = () => {
        removeStepsAndRequests()
        history?.push(AppRoutes?.createRequestStepper())
    }

    return (
        <div className="w-full px-6 py-3.5 sticky bottom-0 left-0 bg-white border-t border-grayLines flex items-center justify-center gap-2">
            {isOffline && checkDuplicateStep ? (
                <MessageTimeSinceLastUpdate page="request list" />
            ) : (
                <WarningCard error={error} />
            )}
            <Button
                onClick={handleCancel}
                variant="tertiary"
                text="Cancel"
                type="button"
            />
            <Button
                type="submit"
                variant="secondary"
                disabled={buttonDisabled}
                onClick={handleNextStep}
                className="lg:w-auto w-full lg:flex-grow-0 flex-grow"
                form={'create-repair-form'}
                text={
                    activeStep?.name === 'Request Details'
                        ? 'Submit Request'
                        : 'Continue'
                }
            />
        </div>
    )
}

RenderFooter.propTypes = {
    steps: PropTypes.arrayOf(
        PropTypes.shape({
            active: PropTypes.bool,
            name: PropTypes.string,
        }),
    ).isRequired,
    error: PropTypes.string,
    isValidForm: PropTypes.bool.isRequired,
    allowSubmitWithError: PropTypes.bool,
    handleNextStep: PropTypes.func.isRequired,
    history: PropTypes.shape({
        push: PropTypes.func.isRequired,
        goBack: PropTypes.func,
    }).isRequired,
}

export default RenderFooter
